import React from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  height: 250px;
  background: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)),
              url(${props => props.$bg || '/images/sub_banner_bg.jpg'}) no-repeat center/cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

const Content = styled.div`
  max-width: 1200px;
  width: 100%;
  padding: 0 10%;
`;

const TopText = styled.h2`
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: -1px;
  span {
    color: #ff9900; /* D와 S에 포인트 컬러 */
    font-weight: 800;
  }
`;

const SubBanner = ({ title, bg }) => {
  return (
    <BannerContainer $bg={bg}>
      <Content>
        <TopText>대한민국 대표 사회적기업 <span>D</span>OOSUNG <span>S</span>YSTEM</TopText>
      </Content>
    </BannerContainer>
  );
};

export default SubBanner;